export default __webpack_public_path__ + "locales/de/VersionHistory.json?hash=5103bbd0f03a09d9fc82e15b499601ed";